"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import useEventStopPropagation from '../../../../helpers/hooks/useEventStopPropagation.mjs';
import { FieldControlPanel } from '../../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../../DataBuilderUI/ActionBar.mjs';
import '../../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../../DataBuilderUI/styles.module.css.mjs';
import '../../../DataBuilderUI/Row.mjs';
import '../../../DataBuilderUI/Title.mjs';
import { SvgIcon } from '../../../SvgIcon/index.mjs';
import { DEFAULT_FIELD_KEY } from '../../data-field.mjs';

function ControlPanelForNonObjectRootField({
  addFieldLabel = "Add Field",
  onAdd
}) {
  const handleOnClick = useEventStopPropagation(() => onAdd(DEFAULT_FIELD_KEY));
  return /* @__PURE__ */ jsx(FieldControlPanel.ButtonGroup, { children: /* @__PURE__ */ jsxs(FieldControlPanel.Button, { onClick: handleOnClick, children: [
    /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Add }),
    addFieldLabel
  ] }) });
}

export { ControlPanelForNonObjectRootField };
